document.addEventListener("DOMContentLoaded", function () {
  // Get the feedback elements
  const feedbackArticle = document.querySelector(".feedback-article");
  const yesButton = document.querySelector(".feedback-article__button--like");
  const noButton = document.querySelector(".feedback-article__button--dislike");
  const yesDiv = document.querySelector(".feedback-article__yes");
  const noDiv = document.querySelector(".feedback-article__no");

  // Hide the feedback response divs initially
  if (yesDiv) yesDiv.style.display = "none";
  if (noDiv) noDiv.style.display = "none";

  // Function to get the WordPress post ID
  function getPostId() {
    // Try to get the post ID from the Gravity Form hidden field
    const hiddenField = document.querySelector(
      'input[name="input_hidden_post_id"]'
    );
    if (hiddenField && hiddenField.value) {
      return hiddenField.value;
    }

    // Try to extract post ID from the Gravity Form shortcode
    const gravityForm = document.querySelector(
      ".feedback-article__no .gform_wrapper"
    );
    if (gravityForm) {
      const formHtml = gravityForm.innerHTML;
      const postIdMatch = formHtml.match(/post_id=(\d+)/);
      if (postIdMatch && postIdMatch[1]) {
        return postIdMatch[1];
      }
    }

    // Fallback: try to get it from the URL
    const urlPath = window.location.pathname;
    const pathParts = urlPath.split("/").filter(Boolean);

    // In WordPress, the last segment of a single post URL is often the post ID or slug
    // If it's a number, it's likely the post ID
    const lastSegment = pathParts[pathParts.length - 1];
    if (/^\d+$/.test(lastSegment)) {
      return lastSegment;
    }

    // If we can't determine the post ID, use a hardcoded value as last resort
    return "1166";
  }

  // Function to handle the feedback submission via AJAX
  function submitFeedback(isPositive) {
    // Get the WordPress post ID
    const postId = getPostId();

    // Create form data for the AJAX request
    const formData = new FormData();
    formData.append("action", "update_course_feedback");
    formData.append("post_id", postId);
    formData.append("is_positive", isPositive ? "1" : "0");

    // Send the AJAX request
    fetch(ajax_object.ajax_url, {
      method: "POST",
      body: formData,
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then(() => {
        // Request completed successfully
      })
      .catch(() => {
        // Silent error handling for production
      });
  }

  // Add click event listener for the "Yes" button
  if (yesButton) {
    yesButton.addEventListener("click", function () {
      // Hide the feedback article and show the "Yes" response
      if (feedbackArticle) feedbackArticle.style.display = "none";
      if (yesDiv) yesDiv.style.display = "block";

      // Submit positive feedback
      submitFeedback(true);
    });
  }

  // Add click event listener for the "No" button
  if (noButton) {
    noButton.addEventListener("click", function () {
      // Hide the feedback article and show the "No" response
      if (feedbackArticle) feedbackArticle.style.display = "none";
      if (noDiv) noDiv.style.display = "block";

      // Submit negative feedback
      submitFeedback(false);
    });
  }
});
